@if (src) {
    <div class="relative w-full overflow-hidden bg-transparent focus-within:ring-2 focus-within:ring-primary focus-within:ring-offset-2 focus-within:ring-offset-gray-100"
        [class]="getAspect()" style="position: relative;">
    
        @if (isLoading()) {
        <div class="w-full h-full relative overflow-hidden rounded-lg" [class]="getDimensions()">
            <div class="absolute inset-0 bg-neutral-quaternary rounded-lg"></div>
            <div class="absolute inset-0 flex items-center justify-center">
                <div class="w-11 h-11 rounded-full bg-white/10 flex items-center justify-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                        class="w-5 h-5 text-white/20 translate-x-0.5" aria-hidden="true">
                        <path d="M8 5.14v14l11-7-11-7z" />
                    </svg>
                </div>
            </div>
            <div class="absolute bottom-0 left-0 right-0 p-3 space-y-2">
                <div class="h-2 rounded-full bg-white/10 w-3/4"></div>
                <div class="h-2 rounded-full bg-white/10 w-1/2"></div>
            </div>
            <div class="skeleton-shimmer rounded-lg"></div>
        </div>
        }
    
        @if (!loadError()) {
            @if (isImage()) {
            <img [src]="imageService.getImageSource(src, 'gallery')" alt="" (load)="hideLoader()" (error)="showError($event)"
                class="pointer-events-none mx-auto overflow-hidden rounded-lg" [class]="getDimensions()">
            } @else if (isVideo()) {
            <video [src]="src" alt="" (loadeddata)="hideLoader()" (error)="showError($event)"
                class="pointer-events-none mx-auto rounded-lg" [class]="getDimensions()">
            </video>
            } @else {
            <img class="object-cover rounded-lg" [class]="getDimensions()"
                src="../../../../../assets/images/placeholder.jpeg" alt="">
            }
        } @else {
        <img class="rounded-lg" [class]="getDimensions()"
            src="../../../../../assets/images/placeholder.jpeg" alt="">
        }
    
    
        <div class="w-full h-full absolute top-0 left-0 p-2">
    
            @if (post && (post.tiktokCarouselFile || post.instagramCarouselFile)) {
            <span
                class="absolute top-2 left-2 inline-flex items-center gap-x-1.5 rounded-md bg-pink-100 p-1 text-xxs text-pink-700">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-4">
                    <path d="M2 7v10" />
                    <path d="M6 5v14" />
                    <rect width="12" height="18" x="10" y="3" rx="2" />
                </svg>
    
            </span>
            }
    
            @if (post && (post.tiktokVideoFile || post.instagramVideoFile)) {
            <span
                class="absolute top-2 left-2 inline-flex items-center gap-x-1.5 rounded-md bg-primary/10 p-1 text-xxs text-accent">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-4">
                    <path
                        d="M15.033 9.44a.647.647 0 0 1 0 1.12l-4.065 2.352a.645.645 0 0 1-.968-.56V7.648a.645.645 0 0 1 .967-.56z" />
                    <path d="M7 21h10" />
                    <rect width="20" height="14" x="2" y="3" rx="2" />
                </svg>
            </span>
            }
    
    
            <div
                class="absolute bottom-0 left-0 w-full flex flex-row justify-between items-center stats-gradient px-1 rounded-b-lg">
                <div class="inline-flex items-center gap-x-0.5 py-1.5 text-xs text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-3">
                        <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
                        <path fill-rule="evenodd"
                            d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 0 1 0-1.113ZM17.25 12a5.25 5.25 0 1 1-10.5 0 5.25 5.25 0 0 1 10.5 0Z"
                            clip-rule="evenodd" />
                    </svg>
                    {{ post && post.views ? formatService.convertIntToString(post.views) : 0 }}
                </div>
    
                <div class="inline-flex items-center gap-x-0.5 py-1.5 text-xs text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-3">
                        <path
                            d="m11.645 20.91-.007-.003-.022-.012a15.247 15.247 0 0 1-.383-.218 25.18 25.18 0 0 1-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0 1 12 5.052 5.5 5.5 0 0 1 16.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 0 1-4.244 3.17 15.247 15.247 0 0 1-.383.219l-.022.012-.007.004-.003.001a.752.752 0 0 1-.704 0l-.003-.001Z" />
                    </svg>
                    {{ post && post.likes ? formatService.convertIntToString(post.likes) : 0 }}
                </div>
    
                <div class="inline-flex items-center gap-x-0.5 py-1.5 text-xs text-white">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-3">
                        <path fill-rule="evenodd"
                            d="M5.337 21.718a6.707 6.707 0 0 1-.533-.074.75.75 0 0 1-.44-1.223 3.73 3.73 0 0 0 .814-1.686c.023-.115-.022-.317-.254-.543C3.274 16.587 2.25 14.41 2.25 12c0-5.03 4.428-9 9.75-9s9.75 3.97 9.75 9c0 5.03-4.428 9-9.75 9-.833 0-1.643-.097-2.417-.279a6.721 6.721 0 0 1-4.246.997Z"
                            clip-rule="evenodd" />
                    </svg>
                    {{ post && post.comments ? formatService.convertIntToString(post.comments) : 0 }}
                </div>
            </div>
        </div>
    
    
    
    
    </div>
    
    } 
    @else {
    <img class="object-cover" [class]="getDimensions()"
        src="../../../../../assets/images/placeholder.jpeg" alt="">
    }